import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { PaymentMethod } from './models';

@Injectable({ providedIn: 'root' })
export class PutPaymentMethodService {
    public constructor(private _http: HttpClient, @Inject(SETTINGS) private _settings: ISettings) {}

    public execute(
        paymentMethodKey: string,
        isVerified: boolean,
        isDefault: boolean
    ): Promise<void> {
        // get payment method
        const url = `${this._settings.httpApiServiceNameUrlMap['paymentsApi']}/v1/payment-method/${paymentMethodKey}`;

        this._http.get<any>(url).subscribe((paymentMethod) => {
            // set isVerified only if originally false
            if (!paymentMethod.isVerified) {
                paymentMethod.isVerified = isVerified;
                paymentMethod.isActive = isVerified;
            }

            paymentMethod.isDefault = isDefault;

            // send put request
            const putURL = `${this._settings.httpApiServiceNameUrlMap['paymentsApi']}/v1/payment-method/${paymentMethodKey}`;
            return this._http.put<void>(putURL, paymentMethod).toPromise();
        });

        return;
    }
}
